import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import ActivationDone from './ActivationDone';
import ActivationError from './ActivationError';
import { activationUrl } from '../../providers/EnvContextProvider';
import './activation.css'

export default function Activation() {
  const {acode} = useParams();
  const [actData, setActData] = useState(null);
  const [errorData, setErrorData] = useState(null);
  
  // Server Get: /auth/activate/{activationCode}

  // Response: 
  //  activationStatus;
  //  message;
  //  sdkIdToken;
  //  sdkAccessToken;

  
  useEffect(()=>{
    const fetchActivation = async () => {        
      const response = await fetch(activationUrl(acode),
        {
         method: 'get',
         headers: {
          'Content-Type': 'application/json'
         }
        }
      );
  
      if (!response.ok) {
        // Unable to Activate.      
        const activationError = await response.json();
        console.error(activationError);
        setErrorData(activationError);
        return activationError;
      }
      else {
        const activationData = await response.json();
        // console.log('[activationData: %s]', JSON.stringify(activationData));
        setActData(activationData);
        return activationData;
      }
    }
    
    fetchActivation();
  }, [acode]);

  return (
    <div className='actWrapper'>
      <div className='activationContainer'>      
        {actData &&  <ActivationDone actData={actData} /> }
        {errorData &&  <ActivationError errorData={errorData} /> }        
      </div>
    </div>
  )
}
